import axios from 'axios';

import { getDataFromStore } from "../../store/getStore"
import { API_BASE_URL } from "../../config/api";
const errorMessage = "Something went wrong. Please try again";


const getToken = () => {
    let auth = getDataFromStore("Auth")
    return auth.auth?.token ? auth.auth?.token : ""
}

export const apiFunction = async (url, method, postData, token, section, extraConfig) => {
    let baseUrl = "";
    if (section === "admin") {
        baseUrl = API_BASE_URL;
    }
    if (section === "admin" && !baseUrl) {
        console.error("REACT_APP_AUTH_URL is not configured.");
        return {
            message: "API base URL is not configured. Check REACT_APP_AUTH_URL in .env",
            status: false,
            code: 0,
        };
    }
    let completeUrl = baseUrl + url;
    let config = {
        method: method,
        url: completeUrl,
        baseUrl,
        route: url,
        data: postData ? postData : {},
    };
    let data;
    if (token) {
        let token = getToken();
        config = {
            ...config,
            headers: {
                Authorization: `Bearer ${token}`,
            }
        };
    }

    if (extraConfig == "blob") {
        config = {
            ...config,
            responseType: 'blob',
        }
    }

    if (extraConfig == "multipart") {
        config.headers = {
            ...config.headers,
            "content-type": "multipart/form-data",
        }
    }
    if (extraConfig == "bypassCaptcha") {
        config.headers = {
            'X-Bypass-Recaptcha': true
        }
    }
    if (extraConfig == "urlencoded") {
        config.headers = {
            ...config.headers,
            "Content-Type": "application/x-www-form-urlencoded"
        }
    }

    await axios({ ...config })
        .then((res) => {
            // console.log(res.data);
            if (extraConfig == "blob") {
                data = res.data
            }
            else {
                data = res.data;
            }
        })
        .catch((err) => {
            if (!err.response) {
                data = {
                    message: errorMessage,
                    code: 0,
                    status: false,
                };
                return;
            }
            let error;
            if (typeof err.response?.data === "string") {
                try {
                    error = JSON.parse(err.response.data);
                } catch {
                    error = { message: err.response.data };
                }
            }
            else {
                error = {
                    ...err.response.data,
                }
            }
            data = {
                ...error,
                code: err.response.status,
                status: false,
            };
        });
    // console.log(config);
    // console.log(data);
    return data;
};